import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import { useAtom } from "jotai";
import {
    ANIMATION_DURATION,
    SLIDE_TRANSITION,
} from "@/features/Navigation/constants/animations";
import {
    rightDrawerOpenAtom,
    RightDrawerSize,
    rightDrawerSizeAtom,
} from "@/features/Navigation/state";

const RIGHT_DRAWER_WIDTH = {
    [RightDrawerSize.DEFAULT]: 386,
    [RightDrawerSize.EXPANDED]: 700,
};

export const RightSidebar = () => {
    const [rightDrawerOpen] = useAtom(rightDrawerOpenAtom);
    const [rightDrawerSize] = useAtom(rightDrawerSizeAtom);

    return (
        <AnimatePresence mode="wait">
            <motion.div
                initial={false}
                animate={{
                    opacity: rightDrawerOpen ? 1 : 0,

                    width: rightDrawerOpen
                        ? RIGHT_DRAWER_WIDTH[rightDrawerSize]
                        : 0,
                }}
                exit={{
                    opacity: rightDrawerOpen ? 1 : 0,
                    width: rightDrawerOpen
                        ? RIGHT_DRAWER_WIDTH[rightDrawerSize]
                        : 0,
                }}
                transition={SLIDE_TRANSITION}
                className={clsx("shrink-0")}
            >
                <motion.aside
                    initial={false}
                    animate={{
                        // paddingRight: rightDrawerOpen ? 32 : 0,
                        // paddingLeft: rightDrawerOpen ? 32 : 0,
                        // paddingTop: rightDrawerOpen ? 32 : 0,
                        // paddingBottom: rightDrawerOpen ? 32 : 0,
                        width: rightDrawerOpen
                            ? RIGHT_DRAWER_WIDTH[rightDrawerSize]
                            : 0,
                    }}
                    exit={{
                        width: rightDrawerOpen
                            ? RIGHT_DRAWER_WIDTH[rightDrawerSize]
                            : 0,
                    }}
                    transition={SLIDE_TRANSITION}
                    className={clsx(
                        "flex flex-col rounded-lg bg-slate-800",
                        "shadow-search-bar",
                        "h-[calc(100vh-64px)] shrink-0",
                        "fixed inset-y-9 right-6",
                        rightDrawerOpen && "border-default border",
                    )}
                >
                    <motion.div
                        id="right-drawer-content"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: rightDrawerOpen ? 1 : 0 }}
                        exit={{ opacity: 0 }}
                        transition={{
                            duration: rightDrawerOpen
                                ? ANIMATION_DURATION
                                : ANIMATION_DURATION * 0.5,
                            ease: "easeInOut",
                            delay: rightDrawerOpen
                                ? ANIMATION_DURATION * 1.5
                                : 0,
                        }}
                        className={clsx(
                            "min-h-0 flex-1 flex-col gap-5 px-6 pb-4",
                            "hide-scrollbar relative flex overflow-y-auto",
                            !rightDrawerOpen && "pointer-events-none",
                        )}
                    />
                </motion.aside>
            </motion.div>
        </AnimatePresence>
    );
};
